/**
 * Field names for the hidden bot trap on public forms.
 *
 * Each form gets its own trap field name so one name on a spam author's skip-list does not
 * disable the trap everywhere. Names must be plausible-but-unused and must never resemble a
 * browser autofill category (email/url/website/company/organization/nickname/username/
 * additional-name), or a password manager will fill the trap and reject real users.
 */
export const BOT_TRAP_FIELDS = {
    register: 'extra_details',
    contact: 'form_note',
} as const;

export type BotTrapFieldName = typeof BOT_TRAP_FIELDS[keyof typeof BOT_TRAP_FIELDS];

/** epoch millis captured when the form was first rendered, used to catch instant submissions */
export const BOT_TRAP_RENDERED_AT_FIELD = 'renderedAt';

export type BotTrapFields = Partial<Record<BotTrapFieldName, string>> & {
    [BOT_TRAP_RENDERED_AT_FIELD]: number;
};
